import { createStore } from 'redux';
import reducer from './reducer/Reducer';

//store
const store = createStore(reducer);

export default store;
